<script>
  import { mapGetters } from "vuex";
  import { PlotMapLayer, PlotMapSource } from "@/config/Map.js";
  import { createNamespacedHelpers } from "vuex";
  import localDbService from "@/services/localDbService";
  // Store
  const {
    mapActions: mapActionsOfLiveMap,
    mapState: mapStateOfLiveMap
  } = createNamespacedHelpers("liveMap");

  export default {
    name: "PlotLayer",
    data() {
      return {
        initialized: false,
        storeUnsubscribe: null
      };
    },
    props: {
      map: Object,
      isReady: { type: Boolean, default: false }
    },
    computed: {
      ...mapGetters({
        filteredPlotCategories: "enterpriseMapSetting/getPlotCategories",
      }),
      ...mapStateOfLiveMap({
        filterPlots: state => state.filterPlots
      })
    },
    watch: {
      isReady() {
        if(this.isReady) {
          this.isMapReady();
          this.setSubscribes();
          this.setFilters();
        }
        if (!this.initialized) {
          this.initialized = true;
        }
      }
    },
    methods: {
      ...mapActionsOfLiveMap([
        "cleanUpVesselDetail",
        "showPlotDetail",
        "setFilterPlots"
      ]),
      bindLayerClick() {
        Object.values(PlotMapLayer).forEach(layer => {
          this.map.on("click", layer.id, (e) => {
            this.cleanUpVesselDetail();
            this.showPlotDetail(e.features[0].properties.id)
          });
        });
      },
      isMapReady() {
        if (!this.initialized) {
          this.bindLayerClick();
          this.setPointerStyle();
        }

        this.map.addLayer({
          id: PlotMapLayer.PlotTextLayer.id,
          type: "symbol",
          source: PlotMapSource.PlotPointSource.id,
          minzoom: 8,
          maxzoom: 19,
          layout: {
            "text-field": "{title}",
            "text-anchor": "top",
            "text-size": 14
          },
          paint: {
            "text-color": "#FFFFFF",
            "text-halo-color": "#000000",
            "text-halo-width": 1
          }
        });

        this.map.addLayer({
          id: PlotMapLayer.PlotSymbolLayer.id,
          type: "symbol",
          source: PlotMapSource.PlotPointSource.id,
          minzoom: 8,
          maxzoom: 19,
          layout: {
            "icon-ignore-placement": true,
            "icon-allow-overlap": true,
            "icon-optional": true,
            "icon-anchor": "bottom",
            "icon-image": "{icon}"
          },
          paint: {}
        });

        this.map.addLayer({
          id: PlotMapLayer.PlotPolygonLayer.id,
          type: "fill",
          source: PlotMapSource.PlotPolygonSource.id,
          minzoom: 8,
          maxzoom: 19,
          paint: {
            "fill-color": {
              type: "identity",
              property: "color"
            },
            "fill-opacity": 0.7
          }
        });

        this.map.addLayer({
          id: PlotMapLayer.PlotPolygonTextLayer.id,
          type: "symbol",
          source: PlotMapSource.PlotPolygonSource.id,
          minzoom: 8,
          maxzoom: 19,
          layout: {
            "text-field": "{title}",
            "text-anchor": "top",
            "text-size": 14
          },
          paint: {
            "text-color": "#FFFFFF",
            "text-halo-color": "#000000",
            "text-halo-width": 1
          }
        });
      },
      filterByPlotCategories(filters) {
        if(!this.map) return;
        Object.values(PlotMapLayer).forEach(layer => {
          if (!this.map.getLayer(layer.id)) {
            return;
          }
          this.map.setFilter(layer.id, filters);
        });
      },
      setSubscribes() {
        this.storeUnsubscribe = this.$store.subscribe(mutation => {
          if (
            mutation.type === "liveMap/SET_FILTER_PLOTS"
          ) {
            if(this.filterPlots){
              let filters = ["in", "category"].concat(this.filterPlots);
              this.filterByPlotCategories(filters);
            }
          }
        });
      },
      async setFilters() {
        let val = await localDbService.getFilterPlots();
        this.setFilterPlots(val);
      },
      setPointerStyle() {
        Object.values(PlotMapLayer).forEach(layer => {
          let self = this;
          this.map.on("mousemove", layer.id, () => {
            self.setCursor(true, self);
          });
          this.map.on("mouseleave", layer.id, () => {
            self.setCursor(false, self);
          });
        });
      },
      setCursor(isPointer, self) {
        self.map.getCanvas().style.cursor = isPointer ? "pointer" : "";
      },
    },
    beforeDestroy() {
      this.storeUnsubscribe();
    }
  }
</script>

<style scoped>

</style>
